import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NatureProduitCrm } from 'src/app/parametrage/core/model/produitCrm/natureProduitCrm';
import { ProduitCrmService } from 'src/app/parametrage/core/service/produit-crm.service';

@Component({
  selector: "app-add-nature-produit-crm",
  templateUrl: "./add-nature-produit-crm.component.html",
  styleUrls: ["./add-nature-produit-crm.component.scss"]
})
export class AddNatureProduitCrmComponent implements OnInit {
  natureProduitCrm: NatureProduitCrm;
  form: FormGroup;
  pressButton: Boolean = false;
  title: string;
  loading = false;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private shared: ProduitCrmService
  ) {}

  ngOnInit() {
    this.form = this.createForm(this.natureProduitCrm);
  }

  createForm(data: NatureProduitCrm) {
    if (data) {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeNatureProduitCrm: [
          data ? data.codeNatureProduitCrm : "",
          Validators.compose([Validators.required])
        ],
        libelleNatureProduitCrm: [data ? data.libelleNatureProduitCrm : ""],
        active: [data ? data.active : null],
      });
    } else {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeNatureProduitCrm: ["", Validators.compose([Validators.required])],
        libelleNatureProduitCrm: [""],
        active: [true, Validators.compose([Validators.required])]      });
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    if (!this.natureProduitCrm) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  createData() {
    this.shared.add(this.form.value).subscribe(
      data => {
        this.activeModal.close();
      },
      error => {
        console.log(error);
        alert("Erreur :" + error);
      }
    );
  }

  updateData() {
    this.shared.update(this.natureProduitCrm.id, this.form.value).subscribe(
      data => {
        this.activeModal.close();
      },
      error => {
        console.log(error);
        alert("Erreur :" + error);
      }
    );
  }
}
